import { ActionFunction1, ActionFunctionAny } from 'redux-actions';
import { AxiosStatic } from 'axios';

export interface MenuDataInfo {
  name: string;
  path: string;
  icon?: JSX.Element | string;
  open?: boolean;
  authority?: string;
  component?: any;
  children?: MenuDataInfo[];
  detail?: MenuDataInfo;
  hidden?: boolean;
  provider?: any;
}

export type RequestDeclare = (...payload: any[]) => AxiosStatic;
export type ActionDeclare = {
  [key: string]: ActionFunctionAny<any>;
};
export type EffectDeclare = {
  [key: string]: any;
};
export type ApiDeclare = { [key: string]: (...payload: any[]) => any };

export interface ModelDeclare {
  namespace: string;
  route?: MenuDataInfo;
  state: any;
  actions: ActionDeclare;
  effects: EffectDeclare;
  apis?: ApiDeclare;
}
